module.exports = __webpack_public_path__ + "assets/img/pic.4a15cf9c.png";